import React from "react";
import { Helmet } from "react-helmet";

const Makhabrash = () => {
  return (
    <div>
      <Helmet>
        <title>(Makhabrash) - Anonymous Messaging Platform</title>
        <meta
          name="description"
          content="(Makhabrash) is a web application that allows users to send messages to anyone anonymously. It is built using React for the frontend and Firebase for backend services."
        />
        <meta
          name="keywords"
          content="Makhabrash, Anonymous, Messaging, Platform, React, Firebase , Web"
        />
        {/* meta for google adsense */}
        <meta
          name="google-adsense-account"
          content="ca-pub-1731586537456086"
        ></meta>
        <meta
          name="keywords"
          content="sarhni,sarehe,sarahah,saraha,sarahaa,موقع صراحات,رسائل مجهولة,رسائل صريحة,صراحة,صراحه,صارح,صارحني,بصراحة"
        />
        <meta
          name="keywords"
          content="مخبرش, صراحة, رسائل, مجهولة, رسائل مجهولة, "
        />
        <meta name="author" content="ali hatem ramadan" />
      </Helmet>
      {/* باقي محتوى التطبيق هنا */}
    </div>
  );
};

export default Makhabrash;
